// extracted by mini-css-extract-plugin
module.exports = {"title":"newsletter-signup-success_title__Bj3BO","text":"newsletter-signup-success_text__nNafx"};